/**
 * 种植作物路由
 */
const CropInfoRouter = {
  path: 'cropInfo',
  name: 'CropInfo',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/CropInfo/index')
}
export default CropInfoRouter
